import * as THREE from 'three';

export class Stars {
	constructor(_maxPos, _size, sceneRef) {
		this.status = true;
		this.dirs = [];

		this.particles = 300;
		this.geometry = new THREE.BufferGeometry();

		this.blacklisted = false;
		this.maxPos = _maxPos;

		this.geometry.setAttribute('position', new THREE.BufferAttribute(this.getRandomParticelPos(this.particles), 3));

		this.material = new THREE.PointsMaterial({
			size: _size,
			depthTest: false,
		});

		let particles = new THREE.Points(this.geometry, this.material);
		particles.renderOrder = -1;

		this.object = particles;
		this.object.position.y = -1;
		//this.status = true;

		sceneRef.add(this.object);

		return this;
	}

	getRandomParticelPos = (particleCount) => {
		const arr = new Float32Array(particleCount * 3);

		for (let i = 0; i < this.particles; i++) {
			let pos = i * 3;
			arr[pos] = Math.random() * this.maxPos.x * 2 - this.maxPos.x;
			arr[pos + 1] = 0;
			arr[pos + 2] = Math.random() * this.maxPos.y * 2 - this.maxPos.y;
		}

		return arr;
	};

	update(x, z, factor) {
		this.object.position.x = x * factor;
		this.object.position.z = z * factor;
	}

	reset() {
		this.blacklisted = false;
	}
}
